var map = {
	"./LexusLogo.png": 450,
	"./icons8-info-48.png": 72,
	"./myInfo.png": 451,
	"./neutral-singpass-button.png": 148,
	"./primary-singpass-button.png": 147,
	"./sgcm-logo.svg": 452,
	"./singpass-logo.png": 149,
	"./tfs-logo.jpg": 453,
	"./warning.png": 151
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 449;